import {
  Subscription,
  ProductWithSubscriptionFromApi,
  SubscriptionRelease,
  ProductBusinessCareSubscriptionFromApi,
  ProductBusinessCareSubscriptionReleaseFromApi,
} from '@/types/subscriptions.interfaces'

import { greaterOrEqual, lowerOrEqual } from '@/utils/semver'

// TODO Remove when all is migrated
export const moduleToSubscriptionMapper = productToSubscriptionMapper

export function productToSubscriptionMapper(
  product: ProductWithSubscriptionFromApi,
  shopVersion: string,
): Subscription {
  return {
    autoRenew: product?.business_care_subscription?.support?.auto_renew === 1,
    endDate: new Date(product?.business_care_subscription?.support?.end_date),
    isActive: product?.business_care_subscription?.support?.active,
    updateIsAvailable: getSubscriptionUpdateAvailability(
      product?.business_care_subscription,
      shopVersion,
    ),
    order: product?.business_care_subscription?.order,
    price: {
      businessCarePrice:
        product?.business_care_subscription?.prices?.business_care_price,
      feePrice: product?.business_care_subscription?.prices?.fee_price,
      productPrice: product?.business_care_subscription?.prices?.product_price,
    },
    productId: product?.id,
    productName: product?.name,
    productDisplayName: product.displayName,
    subscriptionType: product?.business_care_subscription?.support?.type,
    productType: product?.business_care_subscription?.product?.product_type,
    subscriptionPlan: {
      period_unit: product?.business_care_subscription?.support?.renew_period_unit,
      period_value: product?.business_care_subscription?.support?.renew_period_value,
      original_price: product?.business_care_subscription?.support?.price,
    },
    release: {
      lastAuthorized: subscriptionReleaseMapper(
        product?.business_care_subscription?.releases?.last_authorized,
      ),
      lastAvailable: subscriptionReleaseMapper(
        product?.business_care_subscription?.releases?.last_available,
      ),
    },
    startDate: new Date(
      product?.business_care_subscription?.order.invoice_date,
    ),
    canReview: product?.business_care_subscription?.reviews !== null,
    hasReview: product?.business_care_subscription?.reviews?.has_review,
  }
}

function subscriptionReleaseMapper(
  release: ProductBusinessCareSubscriptionReleaseFromApi,
): SubscriptionRelease {
  return {
    compatibleFrom: release.compatible_from,
    compatibleTo: release.compatible_to,
    productVersion: release.product_version,
    releaseDate: new Date(release.release_date),
  }
}

function getSubscriptionUpdateAvailability(
  subscribtion: ProductBusinessCareSubscriptionFromApi,
  shopVersion: string,
): boolean {
  if (subscribtion?.support?.active) {
    return true
  }

  try {
    const lastAvailable = subscriptionReleaseMapper(
      subscribtion?.releases?.last_available,
    )
    const lastAuthorized = subscriptionReleaseMapper(
      subscribtion?.releases?.last_authorized,
    )

    return (
      lastAuthorized.productVersion &&
      lastAvailable.productVersion &&
      lowerOrEqual(
        lastAvailable.productVersion,
        lastAuthorized.productVersion,
      ) &&
      greaterOrEqual(shopVersion, lastAvailable.compatibleFrom) &&
      lowerOrEqual(shopVersion, lastAvailable.compatibleTo)
    )
  } catch (error) {
    console.error(
      'Error while checking subscription update availability',
      error,
    )
    return false
  }
}
